import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, useAuth } from "../lib/api";
import { Logo } from "../components/Shell";

const Shell = ({ title, children }) => (
  <main className="min-h-[80vh] grid place-items-center px-4 py-10 jx-halftone">
    <div className="w-full max-w-md jx-surface jx-ink rounded-3xl p-8 jx-rise"><Logo /><h1 className="text-3xl font-black mt-6 mb-6">{title}</h1>{children}</div>
  </main>
);
const Field = (p) => <input {...p} className="w-full bg-transparent border rounded-xl px-4 h-12 mb-3" />;

function useSubmit(fn) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => { e.preventDefault(); setBusy(true); setError(""); try { await fn(); } catch (er) { setError(errMsg(er)); } setBusy(false); };
  return { busy, error, submit };
}

export function Login() {
  const { setUser } = useAuth(); const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const s = useSubmit(async () => { setUser((await api.post("/auth/login", f)).data); nav("/"); });
  return <Shell title="Welcome back"><form onSubmit={s.submit}>
    <Field data-testid="login-email-input" type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required />
    <Field data-testid="login-password-input" type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
    {s.error && <p data-testid="auth-error" className="text-sm text-red-400 mb-3">{s.error}</p>}
    <button data-testid="login-submit-btn" disabled={s.busy} className="jx-btn w-full h-12">Sign in</button>
    <div className="flex justify-between text-sm mt-4"><Link to="/forgot-password" data-testid="forgot-link" className="jx-muted">Forgot password?</Link><Link to="/register" data-testid="register-link" className="jx-pink">Create account</Link></div>
  </form></Shell>;
}

export function Register() {
  const { setUser } = useAuth(); const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", username: "", display_name: "" });
  const [agree, setAgree] = useState(false);
  const s = useSubmit(async () => { const { data } = await api.post("/auth/register", f); setUser(data); toast.success(`Welcome! You are member #${data.member_number}`); nav("/"); });
  return <Shell title="Join Jixxeo"><form onSubmit={s.submit}>
    <Field data-testid="register-username-input" placeholder="Username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} required />
    <Field data-testid="register-display-input" placeholder="Display name" value={f.display_name} onChange={(e) => setF({ ...f, display_name: e.target.value })} />
    <Field data-testid="register-email-input" type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required />
    <Field data-testid="register-password-input" type="password" placeholder="Password (8+ characters)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
    <label className="flex gap-2 text-xs jx-muted mb-4"><input data-testid="register-agree-checkbox" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />I agree to the <Link to="/policy" className="underline">community guidelines &amp; payout policy</Link>.</label>
    {s.error && <p data-testid="auth-error" className="text-sm text-red-400 mb-3">{s.error}</p>}
    <button data-testid="register-submit-btn" disabled={s.busy || !agree} className="jx-btn w-full h-12">Create account</button>
    <p className="text-sm mt-4 jx-muted">Have an account? <Link to="/login" className="jx-pink">Sign in</Link></p>
  </form></Shell>;
}

export function Forgot() {
  const [email, setEmail] = useState(""); const [done, setDone] = useState(false);
  const s = useSubmit(async () => { await api.post("/auth/forgot-password", { email }); setDone(true); });
  return <Shell title="Reset password">{done ? <p data-testid="forgot-done" className="jx-muted">If that email exists, a reset link has been sent.</p> : <form onSubmit={s.submit}>
    <Field data-testid="forgot-email-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
    <button data-testid="forgot-submit-btn" disabled={s.busy} className="jx-btn w-full h-12">Send reset link</button></form>}</Shell>;
}

export function Reset() {
  const nav = useNavigate(); const [pw, setPw] = useState("");
  const token = new URLSearchParams(window.location.search).get("token");
  const s = useSubmit(async () => { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Password updated"); nav("/login"); });
  return <Shell title="New password"><form onSubmit={s.submit}>
    <Field data-testid="reset-password-input" type="password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} required />
    {s.error && <p className="text-sm text-red-400 mb-3">{s.error}</p>}
    <button data-testid="reset-submit-btn" disabled={s.busy} className="jx-btn w-full h-12">Update password</button></form></Shell>;
}
